import { useTranslation } from 'react-i18next'

import { getObjectsSum } from '../../../utils/common'
import {
  CHART_ANCHORED_TOOLTIP_PROPS,
  CHART_BAR_LAYOUT,
  ChartBar,
  ChartLegend,
} from '../../Chart'
import Text from '../../Text'
import { BIRDVIEW_CHART_LABEL_KEY } from '../DashboardBirdview.constants.charts'
import { formatBirdviewNumber } from '../DashboardBirdview.utils.charts'

import {
  BIRDVIEW_AGING_CHART_BAR_PROPS,
  BIRDVIEW_AGING_CHART_PROPS,
} from './BirdviewAgingChart.constants'
import {
  getBirdviewAgingChartItems,
  getBirdviewAgingChartLegendItems,
  getBirdviewAgingChartXAxisProps,
} from './BirdviewAgingChart.utils'
import { BirdviewAgingChartTooltip } from './BirdviewAgingChartTooltip'

import * as styles from './BirdviewAgingChart.module.css'

function BirdviewAgingChart({ items, total }) {
  const { t } = useTranslation()

  const chartItems = getBirdviewAgingChartItems(items)

  return (
    <div className={styles.aging}>
      <div className={styles.wrap}>
        <div className={styles.columns}>
          <span className={styles.caption}>
            <Text isSecondary className={styles.count}>
              {formatBirdviewNumber(total)}
            </Text>
            <Text isSecondary className={styles.captionText}>
              {t('DashboardBirdview.AgingOpenCaptionKey')}
            </Text>
          </span>
          <div className={styles.chart}>
            <ChartBar
              barProps={BIRDVIEW_AGING_CHART_BAR_PROPS}
              chartProps={BIRDVIEW_AGING_CHART_PROPS}
              data={chartItems}
              layout={CHART_BAR_LAYOUT.columns}
              nameKey={BIRDVIEW_CHART_LABEL_KEY}
              tooltipProps={{
                ...CHART_ANCHORED_TOOLTIP_PROPS,
                content: <BirdviewAgingChartTooltip total={total} />,
              }}
              xAxisProps={getBirdviewAgingChartXAxisProps(chartItems)}
            />
          </div>
        </div>
        <ChartLegend
          className={styles.legend}
          items={getBirdviewAgingChartLegendItems(items)}
        />
      </div>
      <Text isSecondary className={styles.covered}>
        {t('DashboardBirdview.AgingCoveredShareKey', {
          count: formatBirdviewNumber(getObjectsSum(items)),
          min: items[0].minDays,
          total: formatBirdviewNumber(total),
        })}
      </Text>
    </div>
  )
}

export default BirdviewAgingChart
